import { Link } from "react-router-dom";

import { t } from "@/i18n";

export type EmptyStateKind = "not_connected" | "not_supported" | "no_data" | "error";

interface EmptyStateProps {
  kind: EmptyStateKind;
  /** capabilities.py'den gelen makine-okur neden (ör. 'baglanti_eksik'); varsa genel govde metninin yerini alir. */
  reason?: string | null;
  /** Backend'in KENDI hata metni (ör. gidisat.py `hata` alani) — bir i18n
   * anahtari DEGIL, DOGRUDAN gosterilir. Verilirse `reason`'dan ONCELIKLIDIR
   * (inceleme bulgusu: GA4/Meta 'error' durumunda eskiden hep genel
   * "Bağlı değil" govdesi gosterilip gercek hata metni KAYBOLUYORDU). */
  message?: string | null;
  setupHref?: string;
}

/** not_connected / not_supported / error kart durumlari icin ortak bos-durum govdesi (sozlesme §4). */
export function EmptyState({ kind, reason, message, setupHref }: EmptyStateProps) {
  const body = message ?? (reason ? t(`card.reason.${reason}`) : t(`empty.${kind}.body`));
  return (
    <div role="status" className="card flex flex-col items-center gap-2 border-dashed p-5 text-center">
      <p className="font-semibold text-ink">{t(`empty.${kind}.title`)}</p>
      <p className="text-sm text-muted">{body}</p>
      {setupHref && (
        // React Router Link — duz <a> SPA basename'ini atlayip tam sayfa
        // yanlis/olmayan bir yola gider (bkz. KpiCard.tsx ayni desen).
        <Link to={setupHref} className="btn-link min-h-[36px]">
          {t("card.setup_link")}
        </Link>
      )}
    </div>
  );
}
